export class SearchProduct {
  constructor() {}

  get_imgdeft() {
    let Arrayimg = [
      "/uploads/_small/Cubeta-de-plastico.jpg",
      "/uploads/_small/Cubeta-metálica-redonda.jpg",
      "/uploads/_small/Tambo-metálico.jpg",
      "/uploads/_small/Tote-metálico.jpg",
      "/uploads/_small/Porrón.jpg",
    ];
    return Arrayimg[Math.floor(Math.random() * Arrayimg.length)];
  }

  isvalid_key(event) {
    let keys = [
      16, 17, 18, 19, 20, 33, 34, 35, 36, 37, 38, 39, 40, 144, 145, 225, 91, 67,
    ];
    return !keys.includes(event);
  }

  create_product(data) {
    let listProduct = '<section class="row">';
    let catSlug = "";
    let img = "";
    let title = "";
    let divdiscon = "";

    if (data.length === 0) {
      return (listProduct =
        '<p class="text-center"><strong> No se han encontrado resultados de búsqueda.</strong></p>');
    }

    for (var i in data) {
      title = data[i].title;

      catSlug =
        data[i].category == "Especialidades Químicas"
          ? "especialidades"
          : data[i].category.toLowerCase();
      catSlug =
        catSlug == "tratamiento de aguas"
          ? "tida"
          : data[i].category.toLowerCase();
      img = data[i].imageSm;

      if (data[i].imageSm == null) {
        img = this.get_imgdeft();
      }

      if (data[i].discount != null) {
        divdiscon = `<div class="product-card__discount position-absolute px-3 d-flex align-items-center">
          ${data[i].discount}% de descuento
        </div>`;
      }

      listProduct += `
        <article class="col-6 mb-4 col-md-4 col-lg-3">
          <div class="product-card">
            <div class="product-card__tag product-card__tag--${catSlug} small text-uppercase font-bold-italic d-flex align-items-center justify-content-end">
              <p>
                <span class="position-relative">${data[i].category.replace("Especialidades", "Esp.")}</span>
              </p>
            </div>
            <div class="product-card__img position-relative">`;

      if (data[i].url) {
        listProduct += `
          <a href="${data[i].url}" class="pointer info">
            <span class="masInfov2">Más Información</span>
            <picture>
              <img src="${img}" alt="${title}" class="lazy position-absolute h-75">
            </picture>
            ${divdiscon ? divdiscon : ""}
          </a>`;
      } else {
        listProduct += `
          <section>
            <picture>
              <img src="${img}" alt="${title}" class="lazy position-absolute h-75">
            </picture>
            ${divdiscon ? divdiscon : ""}
          </section>
        `;
      }
      listProduct += `
        </div>
        <div class="product-card__body">
          <h3 class="h6 text-royalblue mb-0 font-medium titlefont">${title}</h3>
        </div>
      `;
      /*if (!data[i].url) {
        listProduct += `
        <section class="product-card-btn">
          <a href="#" onclick="getQuote(event, ${title})" class="w-100 block-btn block-btn--sm p-0 p-3">Contacta un asesor</a>
        </section>
        `;
      }*/
      listProduct += `
      <div class="product-card-cotizar pointer">
        <section class="product-card-btn pointer">
          <a class="w-100 block-btn block-btn--newGreen p-0 py-2"
            onclick="openNav('${data[i].category}', '${data[i].title}', 'Cotizar Producto','[]'); return false;">
            Cotizar ahora</a>
        </section>
      </div>
      </div>
      </article>
      `;
    }

    listProduct += "</section>";

    return listProduct;
  }
}
